import { z } from 'zod';
import UIStrings from '@/Utils/UIStrings';
import ValidationErrors from '@/Utils/ValidationErrors';

const scoreConstraintMessage = ValidationErrors.ConstraintNumberError(0, 100);

export const criteriaScoreSchema = z.object({
    userDefinedJustification: z
        .string({ error: ValidationErrors.Required })
        .min(1, ValidationErrors.Required)
        .max(1024, { error: ({ maximum }) => UIStrings.MaxSymbolsValidationError(maximum) }),
    userDefinedScore: z
        .number({ error: ValidationErrors.Required })
        .min(0, scoreConstraintMessage)
        .max(100, scoreConstraintMessage),
});

export type CriteriaScoreFormValues = z.infer<typeof criteriaScoreSchema>;

export const criteriaScoreFieldNames: { [key in keyof CriteriaScoreFormValues]: key } = {
    userDefinedJustification: 'userDefinedJustification',
    userDefinedScore: 'userDefinedScore',
};
